export default "__VITE_ASSET__CmmM$EPm__"